export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101">
    <path
      d="M33.5 28.9c-1.6 1.6-3.2 3.1-4.7 4.4-1.9 1.8-1.4 4.2-1.2 4.8.8 2.2 1.6 4.4 2.3 6.7 1 3.2 1.8 6.4 1.8 9.8 0 1.5-.2 3-1.4 4.1-1.1.9-2.1 1.9-3.3 2.7-3.2 2.4-6.8 3.8-10.5 5.2-3.7 1.4-6.9 3.5-9.4 6.6C3.6 77.8.9 82.7.4 88.5c-.4 4 1.3 7.3 4.4 8.9 2.1 1 4.4 1.1 6.6.8 6.9-1 12.7-4.2 17.3-9.3 1.9-2.1 3.2-4.8 4.6-7.3 1.9-3.3 3.6-6.7 5.5-10 1.1-1.8 2.5-3.5 4.8-3.7 1.6-.1 3.2-.1 4.7.2 4.2.7 8.1 2.2 12 3.9.8.4 3.4 1.6 5.8-.6l5.1-4.8-37.7-37.7zM12.3 92c-2.9 0-5.2-2.5-5.2-5.4 0-2.9 2.5-5.2 5.4-5.2 2.8.1 5.2 2.4 5.2 5.3S15.2 92 12.3 92zm64.4-30.3c12.9-12.4 23.6-23.5 23.8-23.7C93.6 31.1 62.6.8 62.3.5c-.3.2-10.4 10.7-23.5 23.3l37.9 37.9z"
      fillRule="evenodd"
    />
  </svg>
);
